import { render, staticRenderFns } from "./BirthView.vue?vue&type=template&id=6f1c3806&scoped=true"
import script from "./BirthView.vue?vue&type=script&lang=js"
export * from "./BirthView.vue?vue&type=script&lang=js"
import style0 from "./BirthView.vue?vue&type=style&index=0&id=6f1c3806&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c3806",
  null
  
)

export default component.exports